<template>
  <div>
    <editable-chart-title v-if="printable" v-model="reportTitle"></editable-chart-title>
    <highcharts :options="options" ref="highcharts" />
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import ExportingHighcharts from 'highcharts/modules/exporting';
import { Chart } from 'highcharts-vue';
import printableChart from './printableChart';

ExportingHighcharts(Highcharts);

export default {
  name: 'pie-chart',
  mixins: [printableChart],
  props: {
    title: String,
    series: Array,
  },
  watch: {
    title(val) {
      this.chartOptions.title.text = val;
    },
    // HCI-4741: update the options, not the chart. See DonutChart.vue.
    series(val) {
      this.chartOptions.series[0].data = val;
    },
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: 'pie',
          events: {
          },
        },
        title: {
          text: this.title
        },
        tooltip: {
          formatter: function() {
            return `${this.point.name}: ${this.point.y}`;
          }
        },
        plotOptions: {
          pie: {
            depth: 45,
            dataLabels: {
              enabled: true,
              format: '{point.name}: <b>{point.percentage:.1f}%</b>'
            }
          }
        },
        series: [{
          name: '',
          data: this.series,
          size: '100%',
          dataLabels: {
            distance: '10%'
        }
        }],
        credits: {
          enabled: false
        },
      }
    };
  },
  computed: {
    options() {
      return this.applyPrintableTitle(this.chartOptions);
    },
  },
};
</script>

<style scoped>
#container {
  height: 600px;
}
</style>
